angular
  .module 'filters'
  .filter 'waiverSignedBy', () ->
    (waiver) ->
      contact = waiver.signed_waiver_contacts_attributes[0]
      "#{contact.first_name} #{contact.last_name}"
